import { HeartFilled } from "@ant-design/icons";
import { Alert, Button, Col, Input, Rate, Row, notification } from "antd";
import FormControl from "components/UI/FormControl/FormControl";
import { Controller, useForm } from "react-hook-form";
import { Form } from "./Review.style";
import { getDateStringNow } from "library/helpers/dateUtils";
import { getUserToken } from "library/helpers/fonction";
import { loadState } from "library/helpers/localStorage";
import { MSG_DATA_SAVED, MSG_ERREUR_MAX_ONE_FIELD_REQUIRED, MSG_ERREUR_SAUVEGARDE } from "library/helpers/validators/messages";
import React, { useEffect, useState } from "react";

export default function ReviewForm({idHotel, closeModal, resetForm}) {
  const {
    control,
    reset,
    formState: { errors },
    handleSubmit,
  } = useForm({
    mode: "onChange",
  });

  const [api, contextHolder] = notification.useNotification({
    placement: 'topRight',
    top: 100,
    duration: 30
  });

  useEffect (() =>{
    reset();
  },[resetForm, reset])


  const openNotificationWithIcon = (type,message) => {
    api[type]({
      message: 'Notification',
      description: message,
    });
  };

  const onSubmit = (data) => {
    let messageErreur = `${MSG_ERREUR_SAUVEGARDE}`;

    if (!data.note && !data.titre && !data.message) {
      openNotificationWithIcon('error', MSG_ERREUR_MAX_ONE_FIELD_REQUIRED);
      return;
    }

    const user = loadState("user");
    const formData = { 
        ...data,
        client: {
          id: user.id,
        },
        date: getDateStringNow("YYYY-MM-DD"),
        idHotel,
      };

    const token = getUserToken(user);
  
    try {
      fetch(process.env.REACT_APP_API_URL+"/commentaires", {
        "method": "POST",
        headers : {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        "body": JSON.stringify(formData)
      }).then(
        (res) => {
          if(res.ok) {
            openNotificationWithIcon('success',`${MSG_DATA_SAVED}`);
            closeModal();
          } else {
            openNotificationWithIcon('error',messageErreur);
          }
        }
      ).catch(e => {
        console.log(e);
        openNotificationWithIcon('error',messageErreur);
      });
    }
    catch (e) {
      console.log(e);
      openNotificationWithIcon('error',messageErreur);
    }
  };

  return (
    <React.Fragment>
      {contextHolder}
      <Form onSubmit={handleSubmit(onSubmit)} id="reviewFormId">
        <FormControl
          label="Note"
          htmlFor="note"
        >
          <Controller
            name="note"
            defaultValue=""
            control={control}
            rules={{ required: false }}
            render={({ field: { onChange, onBlur, value } }) => (
              <Rate
                character={<HeartFilled />}
                count={5}
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                style={{ color: "rgb(25, 171, 110)" }}
              />
            )}
          />
        </FormControl>
        <FormControl
          label="Titre"
          htmlFor="titre"
        >
          <Controller
            name="titre"
            defaultValue=""
            control={control}
            rules={{ required: false }}
            render={({ field: { onChange, onBlur, value } }) => (
              <Input
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                placeholder="Résumez votre visite ou mettez en évidence un détail intéressant"
              />
            )}
          />
        </FormControl>
        <FormControl
          label="Description"
          htmlFor="message"
        >
          <Controller
            name="message"
            defaultValue=""
            control={control}
            rules={{ required: false }}
            render={({ field: { onChange, onBlur, value } }) => (
              <Input.TextArea
                rows={5}
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                placeholder="Racontez votre expérience"
              />
            )}
          />
        </FormControl>

        <FormControl className="submit-container">
          <Row>
            <Col>
              <Button htmlType="submit" type="primary" size="middle">
                Envoyer
              </Button>
            </Col>
          </Row>
        </FormControl>
      </Form>
    </React.Fragment>
  );
}
